import * as React from "react";
import { Fab, TextField } from "@material-ui/core";
import { Save as SaveIcon } from "@material-ui/icons";
import { useApiClient, useOrg } from "lib/store";
import CardFlex from "screens/components/CardFlex";
import { useErrorHandler } from "../../ErrorHandler";

interface Props {
  className?: string;
}

const Douane: React.FC<Props> = ({ className }) => {
  const api = useApiClient();
  const org = useOrg();
  const [loading, setLoading] = React.useState(false);
  const [numeroAccise, setNumeroAccise] = React.useState("");
  const errorHandler = useErrorHandler();

  React.useEffect(() => {
    setNumeroAccise(
      org.config.douane.numeroAccise ? org.config.douane.numeroAccise : ""
    );
  }, [org]);

  function handleSave() {
    setLoading(true);
    api
      .PUT("/api/orgs/{org}/douane", {
        params: {
          path: {
            org: org.org,
          },
        },
        body: {
          numeroAccise: numeroAccise,
        },
      })
      .catch(errorHandler)
      .finally(() => {
        setLoading(false);
      });
  }

  function handleNumeroAcciseChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    setNumeroAccise(event.target.value.trim().substr(0, 13));
  }

  const actions = (
    <Fab
      color="primary"
      size="small"
      onClick={handleSave}
      aria-label="Enregistrer"
    >
      <SaveIcon />
    </Fab>
  );

  return (
    <CardFlex title="Douanes" actions={actions} loading={loading}>
      <TextField
        fullWidth
        label="Numéro d'accise"
        value={numeroAccise}
        onChange={handleNumeroAcciseChange}
      />
    </CardFlex>
  );
};

export default Douane;
